
export default function Skills() {
  const designSoftware = [
    { name: 'Photoshop', percentage: 95, icon: 'ri-brush-line' },
    { name: 'Canva', percentage: 90, icon: 'ri-palette-line' },
  ];

  const designSkills = [
    { name: 'Typography', percentage: 92 },
    { name: 'Color Theory', percentage: 94 },
    { name: 'Composition', percentage: 89 },
    { name: 'Branding', percentage: 87 },
  ];

  return (
    <section className="relative py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-4 bg-gradient-to-r from-white via-purple-200 to-pink-200 bg-clip-text text-transparent">
            My Skills
          </h2>
        </div>

        {/* Skills Grid */}
        <div className="grid lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {/* Design Software */}
          <div className="p-8 bg-gradient-to-br from-purple-900/20 to-pink-900/20 rounded-3xl border border-purple-500/20">
            <h3 className="text-3xl font-bold mb-8 text-white">Design Software</h3>
            <div className="space-y-6">
              {designSoftware.map((skill, index) => (
                <div key={index}>
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg">
                        <i className={`${skill.icon} text-xl`}></i>
                      </div>
                      <span className="text-lg font-semibold text-white">{skill.name}</span>
                    </div>
                    <span className="text-lg font-bold text-purple-400">{skill.percentage}%</span>
                  </div>
                  <div className="h-3 bg-purple-900/30 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-gradient-to-r from-purple-600 to-pink-600 rounded-full shadow-lg shadow-purple-500/50 transition-all duration-1000"
                      style={{ width: `${skill.percentage}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Design Skills */}
          <div className="p-8 bg-gradient-to-br from-cyan-900/20 to-blue-900/20 rounded-3xl border border-cyan-500/20">
            <h3 className="text-3xl font-bold mb-8 text-white">Design Skills</h3>
            <div className="space-y-6">
              {designSkills.map((skill, index) => (
                <div key={index}>
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-lg font-semibold text-white">{skill.name}</span>
                    <span className="text-lg font-bold text-cyan-400">{skill.percentage}%</span>
                  </div>
                  <div className="h-3 bg-cyan-900/30 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-gradient-to-r from-cyan-500 to-blue-600 rounded-full shadow-lg shadow-cyan-500/50 transition-all duration-1000"
                      style={{ width: `${skill.percentage}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
